import { Modal } from "antd";
import { useSelector } from "react-redux";
import { ModalXIcon } from "../../../../../../assets/icons";
import ComposeTicketForm from "../../../../../Problematikat/SupportInbox/ComposeTicketForm";
import "./ProblemsModal.scss";

/**
 * Create-only modal. Viewing / replying happens in SupportInbox.
 */
const ProblemsModal = ({
  isAddModalVisible,
  setIsAddModalVisible,
  setEditData,
}) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const handleClose = () => {
    setIsAddModalVisible(false);
    setEditData?.({});
  };

  return (
    <Modal
      centered
      className={`problematikaModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      width={720}
      title="Ticket i ri"
      open={isAddModalVisible}
      onCancel={handleClose}
      destroyOnHidden
      closeIcon={<ModalXIcon />}
      footer={null}
    >
      <ComposeTicketForm onCreated={handleClose} onCancel={handleClose} />
    </Modal>
  );
};

export default ProblemsModal;
